import {
  BillingPortalParams,
  BillingSyncResult,
  CallPurchase,
  CheckoutSessionParams,
  ISubscriptionService,
  PhoneBillingData,
  StripeCustomerInspection,
  SubscriptionData,
  UnlinkedStripeSubscription,
} from "./ISubscriptionService";

export class ApiSubscriptionService implements ISubscriptionService {
  private apiBaseUrl: string;

  constructor() {
    this.apiBaseUrl = import.meta.env.VITE_API_BASE_URL || "";
  }

  // TODO: Implement API calls
  async getSubscription(
    userId?: string,
    subscriptionId?: string | number,
  ): Promise<SubscriptionData | null> {
    throw new Error("ApiSubscriptionService.getSubscription not implemented yet");
  }

  async createCheckoutSession(params: CheckoutSessionParams): Promise<string> {
    throw new Error("ApiSubscriptionService.createCheckoutSession not implemented yet");
  }

  async updateSubscriptionQuantity(
    newQuantity: number,
    subscriptionId?: string | number,
  ): Promise<{ success: boolean; message?: string }> {
    throw new Error("ApiSubscriptionService.updateSubscriptionQuantity not implemented yet");
  }

  async getBillingPortalUrl(params: BillingPortalParams): Promise<string> {
    throw new Error("ApiSubscriptionService.getBillingPortalUrl not implemented yet");
  }

  async syncBillingData(): Promise<BillingSyncResult> {
    throw new Error("ApiSubscriptionService.syncBillingData not implemented yet");
  }

  async linkStripeCustomer(userId: string, customerId: string): Promise<BillingSyncResult> {
    throw new Error("ApiSubscriptionService.linkStripeCustomer not implemented yet");
  }

  async listUnlinkedSubscriptions(): Promise<UnlinkedStripeSubscription[]> {
    throw new Error("ApiSubscriptionService.listUnlinkedSubscriptions not implemented yet");
  }

  async inspectStripeCustomer(): Promise<StripeCustomerInspection> {
    throw new Error("ApiSubscriptionService.inspectStripeCustomer not implemented yet");
  }

  isSubscriptionActive(subscription: SubscriptionData | null): boolean {
    if (!subscription || !subscription.ends_at) return false;
    return new Date(subscription.ends_at) > new Date();
  }

  async purchaseAgentCalls(
    agentId: string,
    quantity: number,
  ): Promise<{ success: boolean; message: string; newCallLimit?: number }> {
    throw new Error("ApiSubscriptionService.purchaseAgentCalls not implemented yet");
  }

  async addPhoneNumber(
    params: any,
  ): Promise<{ success: boolean; message: string; subscriptionItemId?: string }> {
    throw new Error("ApiSubscriptionService.addPhoneNumber not implemented yet");
  }

  async removePhoneNumber(phoneNumber: string): Promise<{ success: boolean; message: string }> {
    throw new Error("ApiSubscriptionService.removePhoneNumber not implemented yet");
  }

  async getPhoneSubscriptions(): Promise<any[]> {
    throw new Error("ApiSubscriptionService.getPhoneSubscriptions not implemented yet");
  }

  async getPhoneBilling(): Promise<PhoneBillingData> {
    throw new Error("ApiSubscriptionService.getPhoneBilling not implemented yet");
  }

  async getCallPurchases(): Promise<CallPurchase[]> {
    throw new Error("ApiSubscriptionService.getCallPurchases not implemented yet");
  }

  async getAll(): Promise<any> {
    throw new Error("ApiSubscriptionService.getAll not implemented yet");
  }

  async cancelAgentCalls(agentId: string, quantity?: number): Promise<any> {
    throw new Error("ApiSubscriptionService.cancelAgentCalls not implemented yet");
  }
}
